import React, { lazy, Suspense, useState, useRef, useCallback } from "react";
import { SubHeading } from "../../shared/Components";
// import CommonModal from "../../shared/Components/Modal/CommonModal";
// import { BettingTypeModal } from "../../shared/Components/Modal";
// import BettingTypeSettings from "../GameSettings/BettingTypeSettings";

const BettingTypeBody = lazy(() => import("./BettingTypeBody"));

const BettingType = () => {
  const refetchRef = useRef(null);

  // const [isShow, setIsShow] = useState({
  //   isOpen: false,
  //   rowData: null,
  //   modalTitle: "",
  //   modalContent: null,
  //   modalSize: "md",
  // });

  // const handleModal = (rowData, title = "", modalSize = "md") => {
  //   setIsShow({
  //     isOpen: true,
  //     modalContent: BettingTypeModal,
  //     modalTitle: title,
  //     rowData,
  //     modalSize,
  //   });
  // };

  // const handleBettingTypeSetting = useCallback((rowData) => {
  //   setIsShow({
  //     isOpen: true,
  //     modalContent: BettingTypeSettings,
  //     modalTitle: "Betting Type Settings",
  //     rowData,
  //     modalSize: "xxl",
  //   });
  // }, []);

  return (
    <>
      <SubHeading
        isAdd={false}
        handleShowHide={() => handleModal({}, "Create")}
        isBack={false}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <BettingTypeBody
          onRefetchReady={(fn) => (refetchRef.current = fn)}
          // onBettingTypeSetting={handleBettingTypeSetting}
        />
      </Suspense>

      {/* {isShow?.isOpen && (
        <CommonModal
          size={isShow.modalSize}
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              modalSize: "md",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              fetchData: () => refetchRef.current?.(),
            })}
        </CommonModal>
      )} */}
    </>
  );
};

export default BettingType;
